// heplers
import { generateNykaaUrl } from 'shared/helpers/utils/url';

// types
import { DynamicPageData } from 'shared/routes/DynamicPage/types';

// defs
interface GetMetaInfo {
  categoryURL: string;
  metaInfo: {
    description?: string;
    title?: string;
    keywords?: string[];
    imageUrl?: string;
    noindex?: boolean;
    nofollow?: boolean;
  };
  pathname: string;
  isSearch: boolean;
  isOffer: boolean;
  dynamicPageSlug: string;
  dynamicPageData: DynamicPageData;
  categoryId: string;
}

// constants
const NOINDEX = 'NOINDEX';
const NOINDEX_NOFOLLOW = 'noindex, nofollow';
const NOINDEX_FOLLOW = 'noindex, follow';
const INDEX_NOFOLLOW = 'index, nofollow';

export const getMetaInfo = ({
  categoryURL,
  metaInfo,
  pathname,
  isSearch,
  isOffer,
  dynamicPageSlug,
  dynamicPageData,
  categoryId,
}: GetMetaInfo) => {
  let canonicalUrl = generateNykaaUrl(categoryURL || pathname);
  let metaTitle = metaInfo?.title;
  let metaDescription = metaInfo?.description;
  let metaKeywords = (metaInfo?.keywords && metaInfo?.keywords.join(', ')) || '';
  let noIndexNoFollowRobotMeta = '';

  if (isOffer) {
    noIndexNoFollowRobotMeta = NOINDEX;
  }

  if (isSearch && !dynamicPageSlug) {
    noIndexNoFollowRobotMeta = NOINDEX_NOFOLLOW;
  }

  if (categoryId && metaInfo.noindex !== undefined) {
    const index = !metaInfo.noindex;
    const follow = !metaInfo.nofollow;

    if (!index && follow) noIndexNoFollowRobotMeta = NOINDEX_FOLLOW;
    else if (!index && !follow) noIndexNoFollowRobotMeta = NOINDEX_NOFOLLOW;
    else if (index && !follow) noIndexNoFollowRobotMeta = INDEX_NOFOLLOW;
  }

  if (dynamicPageSlug) {
    const { title, description, canonicalUrl: canonicalURL } = dynamicPageData;
    metaKeywords = '';
    metaTitle = title || '';
    metaDescription = description || '';
    canonicalUrl = canonicalURL;
  }

  return {
    metaTitle,
    metaDescription,
    metaKeywords,
    canonicalUrl,
    noIndexNoFollowRobotMeta,
  };
};
